const vehicle = (
  state = {
    make: null,
    model: null,
    year: null,
    results: null,
    loading: false,
    error: false,
  },
  action,
) => {
  switch (action.type) {
    case 'vehicle/setMake':
      return {
        ...state,
        make: action.payload,
        models: [],
        modelsLoading: false,
        model: null,
        error: false,
      }
    case 'vehicle/setModel':
      return {
        ...state,
        model: action.payload,
        error: false,
      }
    case 'vehicle/setYear':
      return {
        ...state,
        year: action.payload,
        error: false,
      }
    case 'vehicle/results':
      return {
        ...state,
        results: action.payload,
        error: false,
      }
    case 'vehicle/setLoading':
      return {
        ...state,
        loading: action.payload,
        error: false,
      }
    case 'vehicle/error':
      return {
        ...state,
        error: true,
        loading: false,
        results: null,
      }
    default:
      return state
  }
}

export default vehicle
